import { Box, Card, CardContent, Typography, Chip } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

interface IStatData {
  id: number;
  title: string;
  value: string;
  subtitle: string;
  trend: number;
  trendType: "down" | "up";
}

const statsData = [
  {
    id: 1,
    title: "Total Flight Sales",
    value: "₦12,500,000",
    subtitle: "Across all completed bookings",
    trend: 10,
    trendType: "up",
  },
  {
    id: 2,
    title: "Total Ride Sales",
    value: "₦54,200",
    subtitle: "Across all completed bookings",
    trend: 10,
    trendType: "up",
  },
  {
    id: 3,
    title: "Total Flight Trips",
    value: "2,340",
    subtitle: "Total number of flights booked",
    trend: 10,
    trendType: "up",
  },
  {
    id: 4,
    title: "Total Ride Trips",
    value: "765",
    subtitle: "Total number of rides booked",
    trend: 10,
    trendType: "down",
  },
];

export default function StatsCards({ stats }: { stats?: IStatData[] }) {
  const data = stats || [];
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "12px",
        mb: "20px",
      }}
    >
      {data.map((stat) => (
        <Card
          key={stat.id}
          sx={{
            padding: 0,
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            "&:hover": {
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            },
          }}
        >
          <CardContent sx={{ padding: 0, paddingBottom: 0 }}>
            <Box
              sx={{
                paddingX: "22px",
                paddingTop: "22px",
                paddingBottom: "0px",
              }}
            >
              <Typography
                color="#667085"
                fontSize="12px"
                fontWeight={400}
                mb="12px"
              >
                {stat.title}
              </Typography>

              <Typography
                color="#101828"
                fontSize="30px"
                fontWeight={600}
                mb="8px"
              >
                {stat.value}
              </Typography>

              <Typography
                color="#667085"
                fontSize="14px"
                fontWeight={400}
                mb="16px"
              >
                {stat.subtitle}
              </Typography>
            </Box>

            {/* <Box
              sx={{
                paddingTop: "16px",
                paddingBottom: "0px",
                paddingX: "22px",
                borderTop: "1px solid #E4E7EC",
              }}
            >
              <Chip
                icon={
                  stat.trendType === "up" ? <ArrowUpward /> : <ArrowDownward />
                }
                label={`${stat.trend}% from last month`}
                size="small"
                sx={{
                  bgcolor: stat.trendType === "up" ? "#ECFDF3" : "#FEF3F2",
                  color: stat.trendType === "up" ? "#379E66" : "#DA4733",
                  padding: "2px 10px",
                  fontWeight: 400,
                  fontSize: "12px",
                  "& .MuiChip-icon": {
                    color: stat.trendType === "up" ? "#379E66" : "#DA4733",
                    fontSize: "16px",
                  },
                }}
              />
            </Box> */}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
